import { DatasetType } from 'app/model/CORE';
import React, { PureComponent } from 'react';
import { Radio, Space } from 'antd';

type MonitoredDaySelectorProps = {
    dataset: DatasetType;
    value: number;
    onChange: (day: number) => void;
};

export class MonitoredDaySelector extends PureComponent<MonitoredDaySelectorProps> {
    render() {
        const isOperational = this.props.dataset === DatasetType.OPERATIONAL;
        const className = isOperational ? 'tact' : 'pretact';
        return (
            <Radio.Group
                style={{ paddingBottom: '0.5em' }}
                value={this.props.value}
                buttonStyle="solid"
                size="small"
                onChange={e => this.props.onChange(e.target.value)}
                className={'day-selector'}>
                <Space.Compact direction="horizontal">
                    <Radio.Button value={0} className={className}>
                        D0
                    </Radio.Button>
                    <Radio.Button value={1} className={className}>
                        D-1
                    </Radio.Button>
                    <Radio.Button value={2} className={className}>
                        D-2
                    </Radio.Button>
                    <Radio.Button value={3} className={className} disabled={true}>
                        D-3
                    </Radio.Button>
                    <Radio.Button value={4} className={className} disabled={true}>
                        D-4
                    </Radio.Button>
                    <Radio.Button value={5} className={className} disabled={true}>
                        D-5
                    </Radio.Button>
                    <Radio.Button value={6} className={className} disabled={true}>
                        D-6
                    </Radio.Button>
                </Space.Compact>
            </Radio.Group>
        );
    }
}
